import { get } from 'axios'
import { DELETE_CUSTOM_VIEW, RESET_PRODUCT_HIERARCHY_FILTER, SET_DEFAULT_VIEW, UPDATE_TEMP_CUSTOM_VIEW } from './constants'
import { delay, buffers } from 'redux-saga'
import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancel,
  actionChannel
} from 'redux-saga/effects'
import {
  withAuthorization,
  post
} from 'helpers/RequestUtil'
import {
  baseURL
} from 'config'
import * as R from 'ramda'
import P from 'helpers/predicates'
import history from 'startup/history'
import normalize from 'jsonapi-normalizer'
import {
  rowSize as ROW_SIZE,
  MOUNT,
  UNMOUNT,
  ON_MENU_HIDE,
  ON_SUBMIT,
  ON_INPUT_CHANGE,
  ON_INPUT_FILTER_CHANGE,
  ON_FIELD_FILTER_CHANGE,
  ON_REMOVE_FIELD,
  ON_SELECT_FIELD,
  ON_REMOVE_FILTER,
  ON_SELECT_FILTER,
  ON_CLEAR_ALL,
  ON_CLEAR_FILTER,
  ON_HEADER_CLEAR_FILTER,
  ON_DIALOG_CLEAR,
  ON_CANCEL_CLICK,
  ON_SAVE_CLICK,
  ON_FIELD_BUTTON_CLICK,
  ON_PINNED_CLICK,
  ON_ROW_SIZE_CHANGE,
  ON_SECTION_RENDER,
  ON_HEADER_CLICK,
  ON_COLUMN_REORDER,
  ON_HEADER_FILTER_CHANGE,
  ON_HEADER_FILTER_REMOVE,
  ON_SORT_CHANGE,
  ON_APPLY_FILTER,
  ON_INPUT_HEADER_VALUE_CHANGE,
  ROW_THRESHOLD,
  FROM_SIZE,

  SAVE_VIEW,
  ON_SELECT_PRODUCT_FILTER,
  ProductHierarchyEnum,
  UPDATE_CUSTOM_VIEW,
  ON_SELECT_PUBLIC_FILTER,
  EDIT_CUSTOM_VIEW,
  SELECT_ALL_SEARCH_FILTERS,
  DESELECT_ALL_SEARCH_FILTERS,
  SELECT_ALL_SEARCH_SECTION
} from './constants'

import {
  onSortChange,
  onHeaderFilterChange,
  updateCurrentIndex,
  updatePinned,
  updateFrom,
  updateInput,
  updateInputFilter,
  updateFilters,
  updateTotal,
  updateFieldFilterValue,
  updateFieldFilters,
  updateActive,
  updateRowSize,
  updateMaxRowSize,
  updateMenuActive,
  updateListOrder,
  updateHeaderFilter,
  updateInputHeaderList,
  removeHeaderFilter,
  updateSortIndex,
  updateSortType,
  updateSortBy,
  updateCustomColOrder,
  clearCustomColOrder,
  clearTempFieldFilters,
  clearTempQuickFilters,
  removeFilters,
  clearFilters,
  clearHeaderFilters,
  startFetchProjectList,
  fetchProjectListStart,
  fetchProjectListSuccess,
  fetchProjectListError,
  startFetchProjectFilters,
  fetchProjectFiltersStart,
  fetchProjectFiltersSuccess,
  fetchProjectFiltersError,
  postFetchProjectListSuccess,
  updateDisplayFilter,
  copyDisplayFilters,
  removeDisplayFilter,
  updateQuickFilter,
  removeQuickFilter,
  updateAllProductHierarchySources,
  updateProductHierarchyAncestors,
  updateProductHierarchyChildren,
  updateSearchFilters,
  clearProductHierarchyUi,
  productHierarchiesFromQuickFilter,
  selectedProductHierarchiesFromQuickFilter,
  updatePublicFilters,

  updateTempProductFilters,
  updateTempSearchFilters,
  updateSelectedTempProductFilters,
  updateSelectedTempSearchFilters,
  onUpdateViewName,
  onSelectTempCustomView,
  clearViewLabel,
  onSelectCustomView,
  removeCustomView,
  removePublicView,
  clearSearchFiltersUi,
  copyHeaderFilters,
  updateSelectedSearchFilters,
  addToSearchFilters
} from './actions'

import {
  clearData,
} from 'containers/Project/actions'

import {
  error
} from 'containers/App/Notification/actions'

import {
  updateTables,
  updateEntities,
  removeTables,
} from 'containers/Entity/actions'

import {
  inputValueSelector,
  fromStateSelector,
  queryFiltersSelector,
  totalStateSelector,
  rowSizeStateSelector,
  maxRowSizeStateSelector,
  menuActiveStateSelector,
  customColOrderStateSelector,
  listOrderStateSelector,
  headersSelector,
  unformattedHeadersSelector,
  sortByStateSelector,
  sortTypeStateSelector,
  queryFieldFiltersSelector,
  rowSizeValueSelector,
  sortIndexStateSelector,
  currentSortType,
  searchFiltersStateSelector,
  productHierarchyUiStateSelector,
  depthSelector,
  productSkusSelector,
  searchFilterFormElementsSelector,
  productHierarchyListSelector,
  allProductHierarchyStateSelector,
  getActiveCustomViewsSelector,
  searchUiStateSelector,
  viewLabelStateSelector,
  publicViewStateSelector,
  getActiveTempCustomViewSelector,
  headerFiltersStateSelector,
  tempProductFiltersStateSelector,
  tempSearchFiltersStateSelector,
  tempSelectedProductFiltersStateSelector,
  tempSelectedSearchFiltersStateSelector,
  getActivePublicViewsSelector,
  defaultViewSelector,
  projectFiltersEntities,
  projectEntities
} from './selectors'

function* clearProjectList() {
  yield put(removeTables('projects'))
}

function* clear() {
  yield fork(clearProjectList)
  yield put(updateMenuActive(false))
  yield put(updateInput(''))
  yield put(updateInputFilter(''))
  yield put(updateFieldFilterValue(''))
  yield put(clearFilters())
  yield put(clearSearchFiltersUi())
  yield put(clearCustomColOrder())
  yield put(updateTotal(0))
  yield put(updateFrom(0))
  yield put(updatePinned(false))
  yield put(updateRowSize(FROM_SIZE))
  yield put(clearHeaderFilters())
  yield put(clearProductHierarchyUi())
}

function* gatherProjectFeatures(){
  let searchFilters = yield select(projectFiltersEntities)
  let projects = yield select(projectEntities)

  let features = []
  let featureNames = []

  if (projects === undefined) {
    return
  } 
  yield all(Object.values(projects).forEach((project) => {
    if (project['project_features'] === undefined || project === null) {
	return
    }
    Object.entries(project['project_features']).forEach((feature) => {
      if (feature[1] === 'Yes') {
        featureNames.push('project_features.' + feature[0])
      }
    })
  }))
  featureNames = R.uniq(featureNames)
  yield put(updateSelectedSearchFilters(featureNames))
  yield all(Object.values(searchFilters).forEach((entity) => {
    if (featureNames.includes(entity['type'])) {
      features.push(entity['index'])
    }
  }))
  yield put(addToSearchFilters(features))

}

const getChildAction = (name) => {
  let obj = {}
  Object.values(ProductHierarchyEnum).forEach((entry) => {
    if (entry.label === name) {
      obj = entry
    }
  })
  return obj
}
// uses keys as parameter name and value as value
const buildQuery = R.compose(
  R.join('&'),
  R.map(([key, value]) => `${key}=${value}`),
  R.filter(R.propSatisfies(P.isNotEmptyOrNil, '1')),
  R.toPairs
)

function* fetchProductHierarchyChildren(filters, depth) {
  let children = []
  try {
    const { data } = yield call(
      withAuthorization(get),
      `${baseURL}/api/fulcrum/all_product_hierarchy_children?filter[id]=${filters.join(',')}&filter[depth]=${depth}`
    )
    children = data
  } catch(err) {
    yield put(error('Failed to get children'))
  }
  return children
}

function* fetchProductHierarchyAncestors(filter) {
  let ancestors = []
  try {
    const { data } = yield call(
      withAuthorization(get),
      `${baseURL}/api/fulcrum/product_hierarchy_views/${filter}/ancestors`
    )
    ancestors = data
  } catch(err) {
    yield put(error('Failed to get ancestors'))
  }
  return ancestors
}

function* fetchProjectList(urlParams, fieldParams) {
  try {
    yield put(startFetchProjectList())
    yield put(fetchProjectListStart())
    const { data } = yield call(
      withAuthorization(get),
      `${baseURL}/api/search/search?${urlParams}`
    )
    yield put(fetchProjectListSuccess())
    return data
  } catch(err) {
    yield put(fetchProjectListError(err))
    yield put(error('Failed to get projects.'))
  }
}

function* fetchProductFilters() {
  let filters = []
  try {
    const { data } = yield call(
      withAuthorization(get),
      `${baseURL}/api/fulcrum/product_hierarchy_views`
    )
    filters = data
  } catch (err) {
    put(error('Failed to get product filters'))
  }
  return filters
}

function* fetchPublicFilters() {
  let filters = []
  try {
    const { data } = yield call(
      withAuthorization(get),
      '/api/fulcrum/custom_view/get_public_views'
    )
    filters = data
  } catch (err) {
    put(error('Failed to get custom views'))
  }
  return filters
}

function* fetchSearchFilters(filters) {
  let searchFilters = []
  try {
    const { data } = yield call(
      withAuthorization(get),
      `${baseURL}/api/fulcrum/product_hierarchy_form_elements_views?filter[id]=${filters.join(',')}`
    )
    searchFilters = data
  } catch(err) {
    put(error('Failed to get form elements'))
  }
  return searchFilters
}

function* fetchProjectFilters() {
  let filters = []
  try {
    yield put(startFetchProjectFilters())
    yield put(fetchProjectFiltersStart())
    const { data } = yield call(
      withAuthorization(get),
      `${baseURL}/api/search/schema`
    )
    yield put(fetchProjectFiltersSuccess())
    filters = data
  } catch(err) {
    yield put(fetchProjectFiltersError(err))
    yield put(error('Failed to get project filters.'))
  }
  return filters
}

function* postDeleteCustomView(idx) {
  try {
    yield call(
      post,
      'deletes',
      idx,
      '/api/fulcrum/custom_view/delete'
    )
  } catch(err) {
    put(error('Failed to delete custom view'))
  }
}

function* postCustomView(params) {
  try {
    yield call(
      post,
      'creates',
      params,
      '/api/fulcrum/custom_view/creates'
    )
  } catch (err) {
    put(error('Failed to post custom view'))
  }
}

function* postDefaultView(idx) {
  try {
    yield call(
      post,
      'creates',
      idx,
      '/api/fulcrum/custom_view/set_default'
    )
  } catch (err) {
    put(error('Failed to post default view'))
  }
}

function* clearCustomViews() {
  yield put(removePublicView())
  yield put(removeCustomView())
}

function* setURLParams() {
  const query = yield select(inputValueSelector)
  const scopes = yield select(queryFiltersSelector)
  const from = yield select(fromStateSelector)
  const size = yield select(rowSizeValueSelector)
  const sortBy = yield select(sortByStateSelector)
  const sortType = yield select(sortTypeStateSelector)
  const filters = yield select(queryFieldFiltersSelector)
  const sortIndex = yield select(sortIndexStateSelector)
  const fields = yield select(searchFiltersStateSelector)
  const customColOrder = yield select(customColOrderStateSelector)
  const urlParams = buildQuery({
    query,
    from,
    size,
    sortBy,
    sortType,
    scopes: scopes.join(','),
    filters: filters.join(',')
  })
  const otherParams = buildQuery({ fields, sortIndex, customColOrder })
  history.replace(`${history.location.pathname}?${urlParams}&${otherParams}`)
  return urlParams
}

function* handleFetchProjectList() {
  const urlParams = yield call(setURLParams)
  const data = yield call(
    fetchProjectList,
    urlParams
  )
  let response = {}
  if (data) {
    const { hits: { total, hits } } = data
    if (total !== 0) {
      const projectIds = R.map(R.prop('_id'))(hits)
      const projects = R.reduce(
        (acc, { _id: id, _source: source }) =>
          R.assoc(id, { _id: id , id, ...source }, acc)
        ,
        {}
      )(hits)
      let normalized = {
        result: { projects: projectIds },
        entities: { projects }
      }
      yield put(updateTables(normalized))
    }
    const from = yield select(fromStateSelector)
    response = { data, from }
  }
  return response
}

function* handlePreFetchProjectList() {
  yield call(clearProjectList)
  yield put(updateTotal(0))
  yield put(updateFrom(0))
}

function* handlePostFetchProjectList(nextTotal, currentFrom) {
  const total = yield select(totalStateSelector)
  const rowSize = yield select(rowSizeStateSelector)
  const maxRowSize = yield select(maxRowSizeStateSelector)
  yield put(updateTotal(nextTotal))

  if (nextTotal > maxRowSize)
    yield put(updateMaxRowSize(nextTotal))

  if (total === 0 && nextTotal > 0) {
    yield put(updateFrom(rowSize))
  } else {
    yield put(updateFrom(currentFrom + rowSize))
  }
  yield put(postFetchProjectListSuccess())
}

function* handlePublicFilters() {
  const { data } = yield call(fetchPublicFilters)
  yield put(updatePublicFilters(data))
}

function* handleFetchProjectFilters() {
  const data = yield call(fetchProjectFilters)

  const project_filters = P.reduceWithIndex(
    (acc, val, index) => R.assoc(index, { index, ...val }, acc),
    {}
  )(data)
  yield put(updateEntities({ project_filters }))
}

function* handleFetchProductFilters(){
  const data = yield call(fetchProductFilters)
  const product_hierarchy_views = normalize(data) 
  yield put(updateTables(product_hierarchy_views))
  let parse = product_hierarchy_views.entities.product_hierarchy_views
  let obj = {}
  Object.entries(parse).forEach((entry) => {
    let rank = entry[1].rank - 2
    if (rank >= 0) {
      let tier = Object.values(ProductHierarchyEnum)[rank].label
      if (obj[tier]) {
        obj[tier].push(entry[1].id)
      } else {
        obj[tier] = [entry[1].id]
      }
    }
  })
  yield put(updateAllProductHierarchySources(obj))
}

function* handleInputChange({ value }) {
  yield put(updateInput(value))
}

function* handleOnSubmit() {
  yield call(handlePreFetchProjectList)
  const response = yield call(handleFetchProjectList)
  // place holder
  if (R.complement(R.isEmpty)(response)) {
    const { data, from } = response
    yield call(handlePostFetchProjectList, data.hits.total, from)
  }
}

function* autoUpdateHeaderFilters(selected) {
  const previousHeaders = yield select(headerFiltersStateSelector)
  yield put(clearHeaderFilters())
  const productHierarchy = yield select(productHierarchyListSelector)
  const filters = yield select(headersSelector)
  const data = selected.flat()
  

  // think about how to implement this split

  // update product hierarchy header filters
  yield all(data.reduce((acc, productId)=> {
    let ranks = ['product_segment', 'product_line', 'product_family', 'product_platform', 'product_sku', 'product_brand']
    let productRank = productHierarchy[productId].rank - 2
    let id = filters.findIndex( (filter) => filter.type === ranks[productRank])
    if (id !== -1) {
      let params = {
        columnIndex: id,
        filter: productHierarchy[productId].name,
        sort: ''
      }
      acc.push(call(handleOnApplyFilter, params))
    }
    return acc
  }, []))
}

function* handleOnSelectProductFilter({name, filters}) {
  // next update ancestors
  let node = yield getChildAction(name)
  let ancestorData = yield call(fetchProductHierarchyAncestors, filters[0])
  const ancestors = yield normalize(ancestorData)
  yield put(updateProductHierarchyAncestors(node, ancestors))

  // next update children
  let selected = yield select(productHierarchyUiStateSelector)
  let depth = yield select(depthSelector)
  let childrenData = yield call(fetchProductHierarchyChildren, selected.flat(1), depth)

  // reset product filters if all filters are unselected
  if(!childrenData.data.length){
    yield call(handleResetProductFilters)
  }
  else{
    // otherwise continue updating children
    const children = yield normalize(childrenData)
    yield put(updateTables(children))
    yield put(updateProductHierarchyChildren(children))

    // next update searchFilters
    let productSkus = yield select(productSkusSelector)
    let searchFilters = yield call(fetchSearchFilters, productSkus)
    yield put(updateSearchFilters(searchFilters))

    let selectedSearchFilters = yield select(searchFilterFormElementsSelector)
    yield put(copyDisplayFilters(selectedSearchFilters))
    
    yield call(autoUpdateHeaderFilters, selected)
    yield call(gatherProjectFeatures)
    yield fork(clearCustomViews)
  }
}

function* handleInputFilterChange({ value }) {
  yield put(updateInputFilter(value))
}

function* handleSelectFilter({ filter }) {
  yield put(updateFilters(filter))
  yield fork(handleOnSubmit)
}

function* handleRemoveFilter({ filter }) {
  yield put(removeFilters(filter))
  yield fork(handleOnSubmit)
}

function* handleFieldFilterChange({ value }) {
  yield put(updateFieldFilterValue(value))
}

function* handleSelectDisplayFilter({ field }) {
  yield fork(clearCustomViews)
  yield put(updateDisplayFilter(field))
}

function* handleRemoveDisplayFilter({ field }) {
  yield fork(clearCustomViews)
  yield put(removeDisplayFilter(field))
}

function* handleClearFilter() {
  yield put(updateInputFilter(''))
  yield put(clearFilters())
  yield fork(handleOnSubmit)
  yield fork(clearCustomViews)
}

function* handleOnHeaderClearFilter() {
  yield put(clearHeaderFilters())
  yield put(updateInput(''))
  yield fork(handleOnSubmit)
}

function* handleOnHeaderFilterRemove({ filterType, filter }) {
  yield put(removeHeaderFilter(filterType, filter))
  yield fork(handleOnSubmit)
}

function* handleOnDialogClear() {
  yield put(updateFieldFilterValue(''))
  yield put(clearTempFieldFilters())
  yield put(clearTempQuickFilters())
}

function* handleOnClearAll() {
  yield call(clear)
  yield fork(handleOnSubmit)
}

function* updateAllTempFilters() {
  let customView = yield select(getActiveTempCustomViewSelector)
  if (customView === undefined) {
    return
  }
  const {
    selectedFilters,
    searchFilters,
    productHierarchies,
    selectedProductHierarchies,
    label
  } = customView
  yield put(onUpdateViewName(label))
  yield put(updateTempProductFilters(productHierarchies))
  yield put(updateTempSearchFilters(searchFilters))
  yield put(updateSelectedTempProductFilters(selectedProductHierarchies))
  yield put(updateSelectedTempSearchFilters(selectedFilters))
}

function* updateAllFilters(publicClick) {
  let customView = publicClick ? yield select(getActivePublicViewsSelector): yield select(getActiveCustomViewsSelector)
  if (customView === undefined || 'data' in customView) {
    return
  }

  yield call(clear)
  const {
    selectedFilters,
    searchFilters,
    productHierarchies,
    headerFilters,
    selectedProductHierarchies,
    rowSize,
    listOrder
  } = customView

  let formattedHeaderFilters = JSON.parse(headerFilters)
  let formattedListOrder = JSON.parse(listOrder)
  // update all filters
  yield put(updateRowSize(rowSize))
  yield put(updateSearchFilters(searchFilters))
  yield put(copyDisplayFilters(selectedFilters))
  yield put(productHierarchiesFromQuickFilter(productHierarchies))
  yield put(selectedProductHierarchiesFromQuickFilter(selectedProductHierarchies))
  yield put(copyHeaderFilters(formattedHeaderFilters))
  yield put(updateListOrder(formattedListOrder))
  // let selected = yield select(productHierarchyUiStateSelector)

  // use header filters to get new projects
  yield fork(clearProjectList)
  // yield call(copyHeaderFilters, formatted)
  yield fork(handleOnSubmit)

}

function* handleOnSelectPublicFilter({ filter }) {
  yield put(updateQuickFilter(filter))
  yield put(onSelectCustomView(filter))
  yield fork(updateAllFilters, true)
}

function* handleOnRemoveQuickFilter({ filter }) {
  yield put(removeQuickFilter(filter))
}

function* handleOnSaveClick() {
  const filters = yield select(searchFiltersStateSelector)
  yield put(updateFieldFilters(filters))
  yield fork(handleOnSubmit)
}

function* handleOnSaveView() {
  const selectedFilters = yield select(tempSelectedSearchFiltersStateSelector)
  const searchFilters = yield select(tempSearchFiltersStateSelector)
  const productHierarchy = yield select(tempProductFiltersStateSelector)
  const selectedProductHierarchy = yield select(tempSelectedProductFiltersStateSelector)
  const headerFilters = yield select(headerFiltersStateSelector)
  const name = yield select(viewLabelStateSelector)
  const publicView = yield select(publicViewStateSelector)
  const rowSize = yield select(rowSizeStateSelector)
  const listOrder = yield select(listOrderStateSelector)
  const params = {
    selectedFilters,
    searchFilters,
    productHierarchy,
    selectedProductHierarchy,
    name,
    publicView,
    rowSize
  }
  params['headerFilters'] = JSON.stringify(headerFilters)
  params['listOrder'] = JSON.stringify(listOrder)
  yield call(postCustomView, params)
  window.location.reload()
}

function* handleEditView({idx}) {
  yield put(onSelectTempCustomView(idx))
  yield fork(updateAllTempFilters)
  yield put(updateActive(true))
}

function* handleDefaultView({idx}) {
  yield call(postDefaultView, idx)
  window.location.reload()
}

function* handleOnDeleteView({idx}) {
  yield call(postDeleteCustomView, idx)
  window.location.reload()
}

function* handleOnCancelClick() {
  yield put(updateActive(false))
}

function* handleOnRowSizeChange({ size }) {
  yield put(updateRowSize(size))
  yield fork(handleOnSubmit)
  yield fork(clearCustomViews)
}

function* handleOnPinnedClick({ enable }) {
  yield put(updatePinned(enable))
}

function* handleOnHeaderClick({ columnIndex }) {
  const active = yield select(menuActiveStateSelector)
  yield put(updateCurrentIndex(columnIndex))
  yield put(updateInputHeaderList([]))
  yield put(updateMenuActive(true))
}

function* updateColumnOrdering(newColsList) {
  let listOrdering = JSON.parse(JSON.stringify(yield select(listOrderStateSelector)))
  const newColsIndices = R.map(colName => listOrdering[colName])(newColsList).sort((a, b) => a - b)
  newColsList.forEach((col, index) => {
    listOrdering[col] = newColsIndices[index]
  })
  yield put(updateListOrder(listOrdering))
}

function* handleOnColumnReorder({ columnsMoved, targetIndex }) {
  let currSortIndex = yield select(sortIndexStateSelector)
  const headers = yield select(headersSelector)
  const type = R.path([currSortIndex, 'type'])(headers)

  // update column ordering in redux store
  let colsList = yield select(unformattedHeadersSelector)
  targetIndex = (columnsMoved[0] < targetIndex) ? targetIndex - columnsMoved.length : targetIndex
  const moveArrayItemsToNewIndex = (arr, oldIndex, numItems, newIndex) => {
    let itemsToMove = arr.splice(oldIndex, numItems)
    arr.splice(newIndex, 0, ...itemsToMove)
    return arr
  }
  moveArrayItemsToNewIndex(colsList, columnsMoved[0], columnsMoved.length, targetIndex)
  yield call(updateColumnOrdering, colsList)

  // update sort index if reordered columns include currently sorted column
  currSortIndex = colsList.indexOf(type)
  yield put(updateSortIndex(currSortIndex))
  yield put(updateSortType(type))

  // update URL to reflect column reordering
  yield put(updateCustomColOrder(true))
  yield call(setURLParams)
  yield fork(clearCustomViews)
}

function* handleOnMenuHide() {
  yield put(updateMenuActive(false))
}

function* handleOnSectionRender() {
  const scrollChannel = yield actionChannel(ON_SECTION_RENDER, buffers.sliding(1))
  while (true) {
    const { start, stop } = yield take(scrollChannel)
    const from = yield select(fromStateSelector)
    const total = yield select(totalStateSelector)
    const isRender = from - stop < ROW_THRESHOLD
    if (isRender && total !== from) {
      const response = yield call(handleFetchProjectList)
      // place holder
      if (R.complement(R.isEmpty)(response)) {
        const { data, from } = response
        yield call(handlePostFetchProjectList, data.hits.total, from)
      }
    }
    yield call(delay, 300)
  }
}

function* handleOnHeaderFilterChange({ columnIndex, filter }) {
  const headers = yield select(headersSelector)
  yield put(updateHeaderFilter(headers[columnIndex].type, filter))
  yield fork(clearCustomViews)
}

function* handleResetProductFilters() {
  let parse = yield select(productHierarchyListSelector)
  let obj = {}
  Object.entries(parse).forEach((entry) => {
    let rank = entry[1].rank - 2
    if (rank >= 0) {
      let tier = Object.values(ProductHierarchyEnum)[rank].label
      if (obj[tier]) {
        obj[tier].push(entry[1].id)
      } else {
        obj[tier] = [entry[1].id]
      }
    }
  })
  yield put(updateAllProductHierarchySources(obj))
  yield call(clear)
  yield fork(clearCustomViews)
  yield fork(handleOnSubmit)
}

function* handleOnSortChange({ columnIndex, value }) {
  if (value) {
    const headers = yield select(headersSelector)
    const type = R.path([columnIndex, 'type'])(headers)
    yield put(updateSortIndex(columnIndex))
    yield put(updateSortType(type))
    yield put(updateSortBy(value))
  }
}

function* handleOnFieldButtonClick() {
  yield put(updateActive(true))
  yield put(clearViewLabel())
  const searchFilters = yield select(searchUiStateSelector)
  const productHierarchies = yield select(allProductHierarchyStateSelector)
  const selectedFilters = yield select(searchFiltersStateSelector)
  const selectedProductHierarchies = yield select(productHierarchyUiStateSelector)

  yield put(updateTempProductFilters(productHierarchies))
  yield put(updateTempSearchFilters(searchFilters))
  yield put(updateSelectedTempProductFilters(selectedProductHierarchies))
  yield put(updateSelectedTempSearchFilters(selectedFilters))
}

function* handleOnApplyFilter({ columnIndex, filter, sort }) {
  yield put(onHeaderFilterChange(columnIndex, filter))
  yield put(onSortChange(columnIndex, sort))
  yield put(updateMenuActive(false))
  yield fork(handleOnSubmit)
}

function* handleOnSelectCustomView(){
  yield fork(updateAllFilters, false)
}

function* handleOnSelectTempCustomView(){
  yield fork(updateAllTempFilters)
}

function* handleSetDefaultView() {
  let defaultView = yield select(defaultViewSelector)
  yield put(onSelectCustomView(defaultView))
}

function* handleMount(params) {
  const buildFilters = R.compose(
    R.fromPairs,
    R.map(R.apply(R.useWith(
      R.unapply(R.identity),
      [
        R.identity,
        R.match(/((?!=^|\[|\])([^,]))+/g)
      ]
    ))),
    R.map(R.split(':')),
    R.match(/([\w._]*:(\[[^\]]*\]))+/g)
  )

  yield put(clearData())
  if (params) {
    const { fields, sortIndex, query, filters, from, size, sortBy, sortType, scopes, customColOrder } = params
    // if (fields) {
    //   let selectedFields = R.split(',')(fields)
    //   // If there were previous fields already selected
    //   if (selectedFields.length > 1) {
    //     yield put(copyDisplayFilters(selectedFields))
    //   } else {
    //     let searchFilters = yield select(searchFiltersStateSelector)
    //     yield put(copyDisplayFilters(searchFilters))
    //   }
    // }

    if (scopes)
      // yield put(initializeFilters(R.split(',')(scopes)))
    if (filters)
    // this is actually the wrong time to render the header filters. there's a spot after where it loads the custom view
      // yield put(initializeHeaderFilters(buildFilters(filters)))
    if (sortIndex)
      yield put(updateSortIndex(parseInt(sortIndex)))
    if (query)
      yield put(updateInput(query))
    if (sortBy)
      yield put(updateSortBy(sortBy))
    if (sortType)
      yield put(updateSortType(sortType))
    if (customColOrder === 'true'){
      yield put(updateCustomColOrder(customColOrder))
      yield call(updateColumnOrdering, R.split(',')(fields))
    }

    if (size) {
      if (R.any(R.equals(parseInt(size)))(ROW_SIZE)) {
        yield put(updateRowSize(parseInt(size)))
      } else {
        yield put(updateRowSize('View all'))
      }
    }

    const response = yield call(fetchProjectList, 'size=0')
    if (P.isNotNil(response)) {
      const { hits: { total } } = response
      yield put(updateMaxRowSize(total))
      // yield fork(handleOnSectionRender)
    }
  }
}

function* handleDeselectAllSearchFilters() {
  yield fork(handleOnSaveClick)
  yield fork(clearCustomViews)
}

function* handleSelectAllSearchFilters() {
  yield fork(handleOnSaveClick)
  yield fork(clearCustomViews)
}

function* handleSelectAllSearchSectionFilters() {
  yield fork(clearCustomViews)
}

function* handleOnInputHeaderValueChange({ value }) {
  yield delay(500)
  const from = 0,
        size = 0
  const sortType = yield select(currentSortType)
  const urlParams = buildQuery({
    from,
    size,
    //query,
    //scopes: scopes.join(','),
    // filters: filters.join(','),
    aggregate: `${sortType}:${value}`
  })
  const data = yield call(
    fetchProjectList,
    urlParams
  )
  // if aggregations have nested than remove by_nested key
  const field = R.lensPath(['aggregations', sortType])
  const buckets = R.lensPath(['aggregations', sortType, 'buckets'])
  const key = R.lensProp('key')
  const list = R.compose(
    R.view(buckets),
    R.over(buckets, R.map(R.ifElse(
      R.is(String),
      R.identity,
      R.toString
    ))),
    R.over(buckets, R.map(R.view(key))),
    R.over(field, R.ifElse(
      R.has('by_nested'),
      R.path(['by_nested']),
      R.identity
    ))
  )(data)
  yield put(updateInputHeaderList(list))
}

function* watchOnInputChange() {
  yield takeLatest(ON_INPUT_CHANGE, handleInputChange)
}

function* watchOnFieldButtonClick() {
  yield takeLatest(ON_FIELD_BUTTON_CLICK, handleOnFieldButtonClick)
}

function* watchOnInputFilterChange() {
  yield takeLatest(ON_INPUT_FILTER_CHANGE, handleInputFilterChange)
}

function* watchOnFieldFilterChange() {
  yield takeLatest(ON_FIELD_FILTER_CHANGE, handleFieldFilterChange)
}

function* watchOnSelectSearchFilter() {
  yield takeEvery(ON_SELECT_FIELD, handleSelectDisplayFilter)
}

function* watchOnRemoveSearchFilter() {
  yield takeEvery(ON_REMOVE_FIELD, handleRemoveDisplayFilter)
}

function* watchOnSelectFilter() {
  yield takeEvery(ON_SELECT_FILTER, handleSelectFilter)
}

function* watchOnRemoveFilter() {
  yield takeEvery(ON_REMOVE_FILTER, handleRemoveFilter)
}

function* watchOnClearFilter() {
  yield takeEvery(ON_CLEAR_FILTER, handleClearFilter)
}

function* watchOnDialogClear() {
  yield takeEvery(ON_DIALOG_CLEAR, handleOnDialogClear)
}

function* watchOnSaveClick() {
  yield takeEvery(ON_SAVE_CLICK, handleOnSaveClick)
}

function* watchOnSaveViewClick() {
  yield takeLatest(SAVE_VIEW, handleOnSaveView)
}

function* watchOnDeleteViewClick() {
  yield takeLatest(DELETE_CUSTOM_VIEW, handleOnDeleteView)
}

function* watchOnCancelClick() {
  yield takeEvery(ON_CANCEL_CLICK, handleOnCancelClick)
}

function* watchOnSelectPublicFilter() {
  yield takeEvery(ON_SELECT_PUBLIC_FILTER, handleOnSelectPublicFilter)
}

function* watchOnPinnedClick() {
  yield takeLatest(ON_PINNED_CLICK, handleOnPinnedClick)
}

function* watchOnRowSizeChange() {
  yield takeLatest(ON_ROW_SIZE_CHANGE, handleOnRowSizeChange)
}

function* watchOnHeaderClick() {
  yield takeLatest(ON_HEADER_CLICK, handleOnHeaderClick)
}

function* watchOnColumnReorder() {
  yield takeLatest(ON_COLUMN_REORDER, handleOnColumnReorder)
}

function* watchOnSubmit() {
  yield takeLatest(ON_SUBMIT, handleOnSubmit)
}

function* watchOnMenuHide() {
  yield takeEvery(ON_MENU_HIDE, handleOnMenuHide)
}

function* watchOnHeaderFilterChange() {
  yield takeEvery(ON_HEADER_FILTER_CHANGE, handleOnHeaderFilterChange)
}

function* watchOnSortChange() {
  yield takeEvery(ON_SORT_CHANGE, handleOnSortChange)
}

function* watchOnApplyFilter() {
  yield takeEvery(ON_APPLY_FILTER, handleOnApplyFilter)
}

function* watchOnHeaderClearFilter() {
  yield takeEvery(ON_HEADER_CLEAR_FILTER, handleOnHeaderClearFilter)
}

function* watchOnClearAll() {
  yield takeEvery(ON_CLEAR_ALL, handleOnClearAll)
}

function* watchOnHeaderFilterRemove() {
  yield takeEvery(ON_HEADER_FILTER_REMOVE, handleOnHeaderFilterRemove)
}

function* watchOnInputHeaderValueChange() {
  yield takeLatest(ON_INPUT_HEADER_VALUE_CHANGE, handleOnInputHeaderValueChange)
}

function* watchOnSelectProductFilter() {
  yield takeEvery(ON_SELECT_PRODUCT_FILTER, handleOnSelectProductFilter)
}

function* watchOnResetProductFilters() {
  yield takeEvery(RESET_PRODUCT_HIERARCHY_FILTER, handleResetProductFilters)
}

function* watchOnSelectCustomView() {
  yield takeLatest(UPDATE_CUSTOM_VIEW, handleOnSelectCustomView)
}

function* watchOnSelectTempCustomView() {
  yield takeEvery(UPDATE_TEMP_CUSTOM_VIEW, handleOnSelectTempCustomView)
}

function* watchOnEditCustomView() {
  yield takeEvery(EDIT_CUSTOM_VIEW, handleEditView)
}

function* watchSetDefaultView() {
  yield takeEvery(SET_DEFAULT_VIEW, handleDefaultView)
}

function* watchOnDeselectAllSearchFilters() {
  yield takeEvery(SELECT_ALL_SEARCH_FILTERS, handleSelectAllSearchFilters)
}

function* watchOnSelectAllSearchFilters() {
  yield takeEvery(DESELECT_ALL_SEARCH_FILTERS, handleDeselectAllSearchFilters)
}

function* watchOnSelectAllSearchSectionFilters() {
  yield takeEvery(SELECT_ALL_SEARCH_SECTION, handleSelectAllSearchSectionFilters)
}

function* watchMount() {
  let task
  while(true) {
    const {params} = yield take(MOUNT)
    yield call(handleMount, params)
    if (task)
    yield cancel(task)
    yield call(handlePublicFilters)
    yield call(handleFetchProductFilters)
    yield call(handleFetchProjectFilters)
    yield call(handleSetDefaultView)

    // TODO update this in a better way. This is if there is no default view selected.
    let publicView = yield select(getActivePublicViewsSelector)
    let customView = yield select(getActiveCustomViewsSelector)
    if (!publicView && !customView) {
      yield call(handleOnSubmit)
    }
    task = yield fork(handleOnSectionRender)
    yield call(gatherProjectFeatures)
    
    yield take(UNMOUNT)
    yield call(clear)
  }
}

// component load
function* loadComponentSagas() {
  yield all([
    fork(watchOnInputChange),
    fork(watchOnInputFilterChange),
    fork(watchOnFieldFilterChange),
    fork(watchOnSelectFilter),
    fork(watchOnRemoveFilter),
    fork(watchOnSelectSearchFilter),
    fork(watchOnRemoveSearchFilter),
    fork(watchOnClearAll),
    fork(watchOnClearFilter),
    fork(watchOnHeaderClearFilter),
    fork(watchOnSubmit),
    fork(watchOnSaveClick),
    fork(watchOnCancelClick),
    fork(watchOnFieldButtonClick),
    fork(watchOnDialogClear),
    fork(watchOnSelectPublicFilter),
    fork(watchOnPinnedClick),
    fork(watchOnRowSizeChange),
    fork(watchOnHeaderClick),
    fork(watchOnColumnReorder),
    fork(watchOnMenuHide),
    fork(watchOnHeaderFilterChange),
    fork(watchOnSortChange),
    fork(watchOnApplyFilter),
    fork(watchOnHeaderFilterRemove),
    fork(watchOnInputHeaderValueChange),

    // adding new functions from the product fields actions
    fork(watchOnSelectProductFilter),
    fork(watchOnResetProductFilters),
    fork(watchOnSaveViewClick),

    fork(watchOnDeleteViewClick),
    fork(watchOnEditCustomView),


    fork(watchOnSelectCustomView),
    fork(watchOnSelectTempCustomView),
    fork(watchSetDefaultView),

    fork(watchOnDeselectAllSearchFilters),
    fork(watchOnSelectAllSearchFilters),
    fork(watchOnSelectAllSearchSectionFilters)
  ])
}


// global load
function* loadSagas() {
  yield all([
    fork(watchMount)
  ])
}

export {
  loadSagas,
  loadComponentSagas
}
export default loadSagas
